<script>
export default {
  name: "AssignPersonModal",
  props:{
    assignPersonList:{
      type: Array,
      default: () => []
    },
    loadingModal:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      assignPerson: null
    }
  },
  methods:{
    closeModal(){
      this.$bvModal.hide('assign-person-modal')
    },
    confirmModal(){
      this.$emit('confirm',this.assignPerson)
    }
  }
}
</script>

<template>
  <b-modal id="assign-person-modal" title="Phân công người phụ trách" centered hide-footer @show="assignPerson = null" >
    <p>Vui lòng chọn admin để phụ trách hồ sơ này:</p>
    <p>Người phụ trách <span style="color: red">*</span></p>
    <el-select v-model="assignPerson" placeholder="Chọn nhân sự phụ trách" size="medium" style="width: 100%" >
      <el-option
          v-for="item in assignPersonList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
    <div class="d-flex justify-content-end mt-5">
      <button type="button" class="btn btn-secondary mr-4" style="width: 110px" @click="closeModal" :disabled="loadingModal" >Hủy bỏ</button>
      <button type="button" class="btn btn-info" style="width: 110px" @click="confirmModal" :disabled="loadingModal"><i v-if="loadingModal" class="el-icon-loading"></i> Xác nhận</button>
    </div>
  </b-modal>
</template>

<style scoped>

</style>